import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import SettingsSettingWeekendsScreen from "../../../container/Settings/SettingsSettingWeekendsScreen";
import CreateSettingsSettingWeekends from "../../../container/Settings/SettingsSettingWeekendsScreen/CreateSettingsSettingWeekends";

const SettingsSettingWeekendsRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.SETTINGS_SETTINGWEEKENDS.HOME}
          element={
            <SettingsSettingWeekendsScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.SETTINGS_SETTINGWEEKENDS.CREATE}
          element={<CreateSettingsSettingWeekends />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.SETTINGS_SETTINGWEEKENDS.EDIT}
          element={<CreateSettingsSettingWeekends isEdit={true} />}
        />
      )}
    </>
  );
};

export default SettingsSettingWeekendsRoutes;
